import "../create-admins/createAdmins.css";
import "./batch.css";
import { useState } from "react";
import axiosInstance from "../../../api/axios";
import Select from "react-select";

const Batch = () => {
  const [acceptanceList, setAcceptanceList] = useState("");
  const [emails, setEmails] = useState([]);
  const [approvedEmails, setApprovedEmails] = useState([]);
  const [deniedEmails, setDeniedEmails] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [batchType, setBatchType] = useState("accepted");
  const [travelReimbursement, setTravelReimbursement] = useState("false");
  const [housing, setHousing] = useState("false");
  const selectMenuPortalTarget =
    typeof document !== "undefined" ? document.body : null;
  const batchTypeOptions = [
    { value: "accepted", label: "Accept" },
    { value: "waitlisted", label: "Waitlist" },
    { value: "rejected", label: "Reject" },
    { value: "waitlist_accepted", label: "Accept off Waitlist" },
  ];
  const yesNoOptions = [
    { value: "false", label: "No" },
    { value: "true", label: "Yes" },
  ];
  const selectStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(104, 149, 225, 0.28)"
        : state.isFocused
          ? "rgba(255, 195, 157, 0.4)"
          : "#fffdf7",
      color: "#26385f",
      fontSize: "14px",
      ":active": {
        backgroundColor: "rgba(104, 149, 225, 0.34)",
      },
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: "40px",
      borderRadius: "6px",
      borderColor: state.isFocused
        ? "#6895e1"
        : "rgba(52, 69, 117, 0.48)",
      background: "#fffdf7",
      boxShadow: state.isFocused
        ? "0 0 0 3px rgba(104, 149, 225, 0.2)"
        : "none",
      ":hover": {
        borderColor: "#6895e1",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#26385f",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(38, 56, 95, 0.62)",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "rgba(52, 69, 117, 0.32)",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "#a5445b" : "#344575",
      ":hover": {
        color: "#a5445b",
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#fffdf7",
      border: "1.5px solid rgba(52, 69, 117, 0.48)",
      borderRadius: "6px",
      overflow: "hidden",
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#fffdf7",
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };

  const handleAcceptances = (event) => {
    const input = event.target.value;
    setAcceptanceList(input);

    const EMAIL_REGEX = /[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/g;
    const emailArray = input.match(EMAIL_REGEX) || [];
    setEmails(emailArray);
  };

  const handleBatch = (selectedOption) => {
    setBatchType(selectedOption?.value || "accepted");
  };

  const handleSubmitAcceptances = async (event) => {
    event.preventDefault();
    setApprovedEmails([]);
    setDeniedEmails([]);

    for (const email of emails) {
      try {
        const response = await axiosInstance.post(
          `/api/applications/status/${email}`,
          {
            status: batchType,
            travel_reimbursement: travelReimbursement === "true",
            housing_accommodations: housing === "true",
          }
        );

        setApprovedEmails((prevEmails) => [...prevEmails, email]);
      } catch (err) {
        console.error(err);
        setDeniedEmails((prevEmails) => [...prevEmails, email]);
      }
    }

    setFormSubmitted(true);
    setAcceptanceList("");
    setEmails([]);
  };

  return (
    <div className="batch-page">
      <div className="dashboard">
        <h1 className="header-title-batch">Batch Update</h1>
        <div className="searches-ad">
          <form onSubmit={handleSubmitAcceptances}>
            <h1 className="title-ad">
              Batch {batchType.charAt(0).toUpperCase() + batchType.slice(1)}{" "}
              Hackers
            </h1>

            <Select
              options={batchTypeOptions}
              value={
                batchTypeOptions.find((option) => option.value === batchType) ||
                batchTypeOptions[0]
              }
              onChange={handleBatch}
              className="batch-select-wrap"
              classNamePrefix="batch-select"
              styles={selectStyles}
              menuPortalTarget={selectMenuPortalTarget}
              menuPosition="fixed"
              menuPlacement="auto"
              isSearchable={false}
            />

            <p>
              Submit a list of emails and batch {batchType} all hackers in the
              list
            </p>
            <p>
              Note: Hackers will only be notified of their status update when
              the hackathon status is changed to released
            </p>
            <textarea
              className="acceptances-input"
              name="email"
              placeholder="List emails here..."
              value={acceptanceList}
              onChange={handleAcceptances}
            />
            <br />

            {/* Travel Reimbursement */}
            <div className="batch-trav-re">
              <label>Travel Reimbursement:</label>
              <Select
                options={yesNoOptions}
                value={
                  yesNoOptions.find(
                    (option) => option.value === travelReimbursement
                  ) || yesNoOptions[0]
                }
                onChange={(selectedOption) =>
                  setTravelReimbursement(selectedOption?.value || "false")
                }
                className="batch-select-options-wrap"
                classNamePrefix="batch-select"
                styles={selectStyles}
                menuPortalTarget={selectMenuPortalTarget}
                menuPosition="fixed"
                menuPlacement="auto"
                isSearchable={false}
              />
            </div>

            {/* Housing Accommodations */}
            <div>
              <label>Housing Accommodations:</label>
              <Select
                options={yesNoOptions}
                value={
                  yesNoOptions.find((option) => option.value === housing) ||
                  yesNoOptions[0]
                }
                onChange={(selectedOption) =>
                  setHousing(selectedOption?.value || "false")
                }
                className="batch-select-options-wrap"
                classNamePrefix="batch-select"
                styles={selectStyles}
                menuPortalTarget={selectMenuPortalTarget}
                menuPosition="fixed"
                menuPlacement="auto"
                isSearchable={false}
              />
            </div>

            <br />
            <button className="button-batch" type="submit">
              Submit {batchType.charAt(0).toUpperCase() + batchType.slice(1)}
            </button>
          </form>
        </div>

        {formSubmitted && (
          <div className="accepted-or-failed-div">
            <div className="accepted-div">
              <h1 className="acceptances-emails">
                {batchType.charAt(0).toUpperCase() + batchType.slice(1)}{" "}
                Approved
              </h1>
              <ul>
                {approvedEmails.map((email, index) => (
                  <li className="accept" key={index}>
                    {email}
                  </li>
                ))}
              </ul>
            </div>
            <div className="accepted-div">
              <h1 className="acceptances-emails">
                {batchType.charAt(0).toUpperCase() + batchType.slice(1)} Failed
              </h1>
              <ul>
                {deniedEmails.map((email, index) => (
                  <li className="accept" key={index}>
                    {email}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Batch;
